module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 info-bar",
    class: _vm.entity.banner
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-container-columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card paper",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('ul', {
    staticClass: "simple-ul"
  }, [_c('li', [_vm._v(_vm._s(_vm.entity.label))]), _vm._v(" "), _c('li', [_vm._v("Veersedijk 95")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.entity.postcodeCity))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('ul', {
    staticClass: "simple-ul"
  }, [(_vm.entity.tel) ? _c('li', [_c('b', [_vm._v("Tel:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.telTo
    }
  }, [_vm._v(_vm._s(_vm.entity.tel))])]) : _vm._e(), _vm._v(" "), (_vm.entity.telInt) ? _c('li', [_c('b', [_vm._v("Tel int:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.telIntTo
    }
  }, [_vm._v(_vm._s(_vm.entity.telInt))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('span', [_c('b', [_vm._v("Email: ")]), _c('a', {
    attrs: {
      "href": _vm.mailToAddress
    }
  }, [_vm._v(_vm._s(_vm.mailAddress))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('span', [_c('b', [_vm._v("Internet: ")]), _c('a', {
    attrs: {
      "href": _vm.entity.websiteLink,
      "target": "_BLANK"
    }
  }, [_vm._v(_vm._s(_vm.entity.website))])])])])])])]), _vm._v(" "), (_vm.entity.postbox) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card paper",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('ul', {
    staticClass: "simple-ul"
  }, [_c('li', [_vm._v(_vm._s(_vm.entity.postbox))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.entity.postboxAddress))])])])])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Bezoekadres:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Postadres:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fea89ee"}!./src/templates/portal/contact.html
// module id = 545
// module chunks = 1